import { render, staticRenderFns } from "./PublicArticleSearch.vue?vue&type=template&id=1d9725f2&"
import script from "./PublicArticleSearch.vue?vue&type=script&lang=js&"
export * from "./PublicArticleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports